import { EnvironmentProviders, Provider } from '@angular/core';
import { provideDokaLogin } from '@doka/identity-login';
import { authCodeFlowConfig } from '../../environments/environment';
import { provideTokenRefresh } from './provide-token-refresh';

// Replaced by provide-auth.e2e.ts in the e2e build configuration (see angular.json).
export function provideAuth(): (Provider | EnvironmentProviders)[] {
  return [
    provideDokaLogin({
      authCodeFlowConfig: {
        ...authCodeFlowConfig,
        // angular-oauth2-oidc accepts access tokens up to 10 min (default clock skew) past their expiry, the IDS and API only 5 min.
        // Shorten that so a stale token on page load leads to a new login instead of a failing userinfo call that blocks the app start.
        decreaseExpirationBySec: 6 * 60,
      },
      rootUrl: '/my-tasks',
      useServiceWorker: false,
    }),
    provideTokenRefresh(),
  ];
}
